import { useCurrentUser } from "hooks/use-current-user"
import { useStaticFeature } from "hooks/use-feature"
import { getOptInEligibleStates } from "pages/signals/constants"

export const useSignalsOptInEligibility = () => {
  const { refreshSignalsAccessLevel } = useCurrentUser()
  const signalsInCoreAppEnabled = useStaticFeature(
    "signals_in_core_app"
  ).enabled
  const signalsExpansionEnabled = useStaticFeature(
    "signals_in_app_expansion"
  ).enabled
  const endTrialEarlyEnabled = useStaticFeature(
    "signals_end_trial_early"
  ).enabled

  return async serviceLevel => {
    if (
      !signalsInCoreAppEnabled ||
      !signalsExpansionEnabled ||
      serviceLevel !== "creator_pro"
    ) {
      return false
    }

    try {
      const { state } = await refreshSignalsAccessLevel()
      return getOptInEligibleStates(endTrialEarlyEnabled).includes(state)
    } catch (error) {
      window.SentryClient?.captureException(error)
      return false
    }
  }
}
